export default class RefreshTokenRequest {
	jwtToken: string;
	rememberMe: boolean;

	constructor(jwtToken: string, rememberMe: boolean) {
		this.jwtToken = jwtToken;
		this.rememberMe = rememberMe;
	}
}
